var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "11", height: "10", viewBox: "0 0 11 10", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Read-Receipts-Web/Mweb", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Read-receipt-button---first-time-appear---unread---320px", transform: "translate(-299 -250)", fill: "#34F" },
        React.createElement(
          "g",
          { id: "Message-states-/-Sent", transform: "translate(253 247)" },
          React.createElement(
            "g",
            { id: "Read-Receipts-/-unread-/-Gray", transform: "translate(46 3)" },
            React.createElement("path", { d: "M9.205 1.093c-.183.218-1.396 1.705-2.649 3.238L4.419 6.944 2.146 4.881c-.229-.237-.549-.303-.831-.17-.282.132-.479.44-.51.8-.032.359.106.71.36.909l2.843 2.582c.324.294.78.257 1.067-.085.183-.219 1.396-1.7 2.65-3.234 1.252-1.533 2.544-3.119 2.631-3.223.24-.28.31-.704.18-1.07-.132-.367-.438-.601-.772-.59a.759.759 0 0 0-.559.293z", id: "check" })
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/unread_indicator.svg